import { ComponentType } from 'react';
import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { setCurrentTierId, unsetCurrentTierId } from '../actions';
import { getCurrentTierId, getCurrentTier } from '../selectors';
import { PapiDeviation } from '@wix/da-papi-types';

export type WithCurrentTierProps = {
  currentTier: PapiDeviation | undefined;
  currentTierId?: number;
  setCurrentTierId: (tierId: number) => any;
  unsetCurrentTierId: () => any;
};

type StateProps = Pick<WithCurrentTierProps, 'currentTier' | 'currentTierId'>;
type DispatchProps = Pick<WithCurrentTierProps, 'setCurrentTierId' | 'unsetCurrentTierId'>;
type OwnProps = Omit<WithCurrentTierProps, keyof (StateProps & DispatchProps)>;

export const useCurrentTier = (): WithCurrentTierProps => ({
  ...useMMSelector(
    state => ({
      currentTierId: getCurrentTierId(state),
      currentTier: getCurrentTier(state),
    }),
    shallowEqual
  ),
  ...useMMDispatchActions({
    setCurrentTierId,
    unsetCurrentTierId,
  }),
});

export default <TProps>(
  component: ComponentType<TProps & WithCurrentTierProps>
): ComponentType<TProps> =>
  connectMediaStore<StateProps, DispatchProps, OwnProps>(
    state => ({
      currentTierId: getCurrentTierId(state),
      currentTier: getCurrentTier(state),
    }),
    {
      setCurrentTierId,
      unsetCurrentTierId,
    }
  )(component as ComponentType<any>); // redux typings are a bit dumb with generics
